import { pushKey, pushPricesKey } from "@/shared/constants/queryKeys";
import { useQuery } from "@tanstack/react-query";
import { AxiosResponse } from "axios";

import pushUseCases from "@/features/push/domain/use-cases/push";
import {
  GetPushByIdResponse,
  GetPushPricesResponse,
  pushDataSourceImplementation
} from "@/features/push/infrastructure/datasources/push/pushDataSourceImplementation";
import httpImplementation from "@/features/push/infrastructure/services/http/httpImplementation";

export const usePricesQuery = () => {
  const httpClient = httpImplementation();
  const pushDataSourceImpl = pushDataSourceImplementation(httpClient);
  const useCase = pushUseCases(pushDataSourceImpl);

  return useQuery({
    queryKey: [pushPricesKey],
    queryFn: () =>
      useCase.getPushPrices<AxiosResponse<GetPushPricesResponse>>(),
    select: (response) => {
      return response.data;
    }
  });
};

export const useGetPushByIdQuery = (pushId?: string) => {
  const httpClient = httpImplementation();
  const pushDataSourceImpl = pushDataSourceImplementation(httpClient);
  const useCase = pushUseCases(pushDataSourceImpl);

  return useQuery({
    queryKey: [pushKey, pushId],
    queryFn: () =>
      useCase.getPushById<AxiosResponse<GetPushByIdResponse>>(pushId),
    select: (response) => response.data,
    enabled: !!pushId
  });
};
